function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "check_svg__a",
  x: 51,
  y: 51,
  width: 423,
  height: 423,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "offset"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 2.236
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.06,
  result: "flood"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in",
  result: "composite"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  result: "blend"
})), /*#__PURE__*/React.createElement("style", null, ".check_svg__cls-3{fill:#fff;fill-rule:evenodd}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 262,
  cy: 262,
  r: 262,
  fill: "#5d93fe"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 262,
  cy: 262,
  r: 207,
  fill: "#5d93fe",
  filter: "url(#check_svg__a)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "check_svg__cls-3",
  d: "M193.89 240.95l81.132 65.065a9 9 0 011.391 12.652l-25.651 31.985a9 9 0 01-12.652 1.39l-81.132-65.065a9 9 0 01-1.391-12.652l25.651-31.985a9 9 0 0112.652-1.39z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "check_svg__cls-3",
  d: "M206.25 314.7l127.39-144.5a9.721 9.721 0 0113.35-1.047l29.679 24.286a8.9 8.9 0 011.08 12.862l-127.39 144.5a9.721 9.721 0 01-13.35 1.047l-29.675-24.286a8.9 8.9 0 01-1.087-12.861z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 524 524"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgCheck;